import { jsx as _jsx } from "react/jsx-runtime";
//-----------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useEffect } from "react";
import { isDesktop, isMobile } from "react-device-detect";
import { Controllers } from "@react-three/xr";
import { OrbitControls } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
//-----------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTControls for the VTCanvas
export default function VTControls(_a) {
    var screenShot = _a.screenShot;
    var _b = useThree(), gl = _b.gl, camera = _b.camera, scene = _b.scene;
    useEffect(function () {
        if (screenShot) {
            takeScreenShot();
        }
    }, []);
    function takeScreenShot() {
        gl.render(scene, camera);
        var screenshot = gl.domElement.toDataURL();
        screenShot(screenshot);
    }
    //---------------------------------------------------------------------------------------------
    // ## RETURN ##
    // If Vr Render controllers
    if (!isDesktop && !isMobile) {
        return _jsx(Controllers, {});
    }
    //---------------------------------------------------------------------------------------------
    // If desktop Render controls
    else {
        return (_jsx(OrbitControls, { camera: camera, enableZoom: false, enableDamping: true, makeDefault: true, dampingFactor: true ? 0.1 : 0, rotateSpeed: -0.5, position: [0, 0, -0.1], onStart: function () { }, onEnd: function () {
                if (screenShot) {
                    takeScreenShot();
                }
            } }));
    }
}
